namespace GeniuzPOS.Inventory {
    export interface IcStockReturnInData extends Serenity.ListRequest {
        Header?: IcStockReturnInRow;
        Details?: IcStockReturnInDtRow[];
        SysDocNo?: string;
        Para?: Administration.CsParaRow;
        URLpic?: string;
        BizName?: string;
        BizAddressLine1?: string;
        BizAddressLine2?: string;
        BizAddressLine3?: string;
        TaxId?: string;
    }
}
